<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-left">
        <div class="footer-logo">
          <p>康道道<br />医药广阔市场全渠道数字化赋能平台</p>
        </div>
        <a href="https://kdd.binjiela.com.cn" target="_blank" class="footer-login">登录管理后台</a>
      </div>
      <div class="divider"></div>
      <div class="footer-center">
        <h4>联系我们</h4>
        <p>联系地址：浙江省杭州市西湖区三墩镇之江<br />科创中心A座7楼702室</p>
        <p>联系电话：0571-1234 1234</p>
        <div class="contact-icons">
          <img src="@/assets/wechat.png" alt="请扫二维码" />
          <img src="@/assets/email.png" alt="请扫二维码" />
        </div>
      </div>
      <div class="divider"></div>
      <div class="footer-right">
        <h4>商务合作</h4>
        <div class="qrcodes">
          <div class="qrcode">
            <img src="@/assets/qr-code-1.png" alt="请扫二维码" />
            <p>请扫二维码</p>
          </div>
          <div class="qrcode">
            <img src="@/assets/qr-code-2.png" alt="请扫二维码" />
            <p>请扫二维码</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <p>服务协议 | 隐私政策 | 版权所有 © 康道道 保留所有权利</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>

<style scoped>
.footer {
  background: #ffffff;
  padding: 74px 0 37px;
  border-top: 1px solid #e2e2e2;
}
.footer-container {
  max-width: 1200px;
  margin: 0 auto 79px;
  display: flex;
  justify-content: space-between;
  gap: 40px;
}
.footer-left {
  flex: 1;
}
.footer-logo {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
}
.footer-logo p {
  color: #333333;

  font-family: PingFang MO;
  font-weight: 600;
  font-style: normal;
  font-size: 20px;
  leading-trim: NONE;
  line-height: 28px;
  letter-spacing: 0;
}
.footer-login {
  background: #009688;
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  text-decoration: none;
}
.footer-center,
.footer-right {
  flex: 1;
}
.footer-center h4,
.footer-right h4 {
  margin-bottom: 16px;
  color: #333;
  font-family: PingFang MO;
  font-weight: 600;
  font-style: normal;
  font-size: 24px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0;
}
.footer-center p {
  color: #797e95;
  margin-bottom: 9px;
  margin-top: 0;

  font-family: PingFang MO;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: 0;
}
.contact-icons {
  display: flex;
  gap: 20px;
  margin-top: 10px;
  img {
    width: 36px;
    height: auto;
    cursor: pointer;
  }
}
.qrcodes {
  display: flex;
  gap: 20px;
}
.qrcode {
  text-align: center;
}
.qrcode img {
  width: 80px;
  height: 80px;
  margin-bottom: 4px;
}
.qrcode p {
  font-size: 12px;
  color: #666;
}
.footer-bottom {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  font-size: 12px;
  color: #797e95;
  line-height: 20px;
  height: 20px;
}
.divider {
  width: 1px;
  background: #d9d9d9;
}
</style>
